import emailjs from '@emailjs/browser';

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const ADMIN_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
const USER_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_USER_TEMPLATE_ID;
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;

export interface OrderData {
    full_name: string;
    email: string;
    phone: string;
    plan_name: string;
    amount_paid: number;
    payment_id: string;
    address: string;
    dob: string;
}

export const sendAdminNotification = async (data: OrderData) => {
    if (!SERVICE_ID || !ADMIN_TEMPLATE_ID || !PUBLIC_KEY) {
        console.warn('EmailJS credentials for admin notification missing. Email not sent.');
        return;
    }

    try {
        const response = await emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, {
            full_name: data.full_name,
            email: data.email,
            phone: data.phone,
            plan_name: data.plan_name,
            amount_paid: data.amount_paid,
            payment_id: data.payment_id,
            address: data.address,
            dob: data.dob,
        }, PUBLIC_KEY);
        console.log('Admin notification email sent successfully!', response.status, response.text);
        return response;
    } catch (error) {
        console.error('Failed to send admin notification email:', error);
        throw error;
    }
};

export const sendUserWelcomeEmail = async (data: OrderData) => {
    if (!SERVICE_ID || !USER_TEMPLATE_ID || !PUBLIC_KEY) {
        console.warn('EmailJS credentials for user welcome email missing. Email not sent.');
        return;
    }

    try {
        const response = await emailjs.send(SERVICE_ID, USER_TEMPLATE_ID, {
            full_name: data.full_name,
            email: data.email, // This 'email' var must be mapped to 'To Email' in EmailJS dashboard
            plan_name: data.plan_name,
        }, PUBLIC_KEY);
        console.log('User welcome email sent successfully!', response.status, response.text);
        return response;
    } catch (error) {
        console.error('Failed to send user welcome email:', error);
        throw error;
    }
};

// Deprecated wrapper for backward compatibility if needed, or just update calls
export const sendOrderEmail = async (data: OrderData) => {
    try {
        await Promise.all([
            sendAdminNotification(data),
            sendUserWelcomeEmail(data)
        ]);
        console.log('All order-related emails sent successfully');
    } catch (error) {
        console.error('Error sending one or more order-related emails:', error);
        throw error; // Re-throw to indicate failure to the caller
    }
};
